import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModalAssinadorService {

    private urlApi: string = 'http://localhost:4567/api/';
    private VERSAO: number = 4;

    constructor(private http: HttpClient) { }

    getAlias(): Observable<any> {
        return this.http.get('http://localhost:4567/api/assinar/alias');
    }

    verConversao(arquivo: File, orientacao: 'v' | 'h'): Promise<any> {
        let p = new Promise((resolve, reject) => {
            var formData = new FormData();

            formData.append("file", arquivo);
            formData.append("orientacao", orientacao);

            var xhr = new XMLHttpRequest();
            xhr.open("POST", 'http://localhost:4567/api/a1/ver-conversao');
            xhr.responseType = 'arraybuffer';
            xhr.onload = function () {
                if (xhr.status == 200) {
                    resolve(xhr.response);
                } else {
                    const decoder = new TextDecoder("utf-8");
                    reject(decoder.decode(xhr.response as ArrayBuffer));
                }
            }
            xhr.onerror = function () {
                reject('API do assinador não se encontra online');
            }

            xhr.send(formData);
        }); return p;
    }

    // assinar(file: File, a: any, tipo: String): Promise<any> {
    //     let p = new Promise((resolve, reject) => {
    //         var formData = new FormData();

    //         formData.append("file", file);
    //         formData.append("dados", JSON.stringify(a));
    //         formData.append("v", '2');//Caso seja diferente da versão interna no assinador, retorna erro forçando baixar novamente o assinador

    //         var xhr = new XMLHttpRequest();
    //         xhr.open("POST", 'http://localhost:4567/api/assinar/' + (tipo == 'A3' ? 'verificado' : 'livre'));
    //         xhr.onload = function () {
    //             var response = JSON.parse(xhr.responseText);
    //             if (xhr.status == 200) {
    //                 resolve(response);
    //             } else {
    //                 reject(response);
    //             }
    //         }
    //         xhr.onerror = function () {
    //             reject('API do assinador não se encontra online');
    //         }

    //         xhr.send(formData);
    //     });

    //     return p;
    // }

    assinar(arquivo: File, dados: any, tipo: string): Promise<any> {
        if (tipo == 'A1') {
            return this.assinarA1(arquivo, dados);
        } else {
            return this.assinarA3(arquivo, dados);
        }
    }

    assinarA1(file: File, a: any): Promise<any> {
        let p = new Promise((resolve, reject) => {
            var formData = new FormData();

            formData.append("file", file);
            formData.append("dados", JSON.stringify(a));
            formData.append("v", this.VERSAO + '');

            var xhr = new XMLHttpRequest();
            xhr.open("POST", 'http://localhost:4567/api/a1/assinar');
            xhr.responseType = 'arraybuffer';
            xhr.onload = function () {
                if (xhr.status == 200) {
                    resolve(xhr.response);
                } else {
                    const decoder = new TextDecoder("utf-8");
                    reject(decoder.decode(xhr.response as ArrayBuffer));
                }
            }
            xhr.onerror = function () {
                reject('API do assinador não se encontra online');
            }

            xhr.send(formData);
        });

        return p;
    }

    assinarA3(file: File, a: any): Promise<any> {
        let p = new Promise((resolve, reject) => {
            var formData = new FormData();

            formData.append("file", file);
            formData.append("dados", JSON.stringify(a));
            formData.append("v", this.VERSAO + '');

            var xhr = new XMLHttpRequest();
            xhr.open("POST", 'http://localhost:4567/api/a3/assinar');
            xhr.responseType = 'arraybuffer';
            xhr.onload = function () {
                if (xhr.status == 200) {
                    resolve(xhr.response);
                } else {
                    const decoder = new TextDecoder("utf-8");
                    reject(decoder.decode(xhr.response as ArrayBuffer));
                }
            }
            xhr.onerror = function () {
                reject('API do assinador não se encontra online');
            }

            xhr.send(formData);
        });

        return p;
    }

    assinadorOnline(chave: string): Observable<any> {
        return this.http.get(`${this.urlApi}${chave.toLowerCase()}/`);
    }

}
